import {IPlaylistsStore} from './playlists.interface';

export const playlistsStoreInitialState: IPlaylistsStore = {
  playlists: []
};
